import { forwardRef } from "react";
import { CalendarOutlined, DownOutlined } from "@ant-design/icons";

const BookMeTrigger = forwardRef(function BookMeTrigger({ className = "", label = "Book Me", meta, ...props }, ref) {
  return <button ref={ref} type="button" className={`bookMeBlock__trigger ${className}`} {...props}>
    <span className="linkPageRenderer__cardIcon"><CalendarOutlined aria-hidden="true" /></span>
    <span className="linkPageRenderer__cardContent"><strong className="linkPageRenderer__cardTitle">{label || "Book Me"}</strong>
      {meta ? <span className="linkPageRenderer__cardSubtitle">{meta}</span> : null}</span>
    <DownOutlined aria-hidden="true" />
  </button>;
});

export default BookMeTrigger;
